import { NavigateFunction } from "react-router-dom";

export const history = {
    navigate: null as unknown as NavigateFunction,
    location: null
} as { navigate: NavigateFunction, location: any };
